module.exports = __webpack_public_path__ + "static/burger200_1-76a16b09462aff669251a1468e883ee0.png";